import { jsx as b, jsxs as S } from "react/jsx-runtime";
import { c as d } from "./index-65016bfa.mjs";
import D, { createContext as K, useContext as C, createElement as A, useRef as B, useState as g, useLayoutEffect as M, useEffect as Q } from "react";
import u, { css as T } from "styled-components";
import { u as E } from "./useAccessibilityProps-2f24cf29.mjs";
import "@fcamna/shared-component-foundations";
import "./setup-0f23222d.mjs";
import "./table.js";
import { u as U } from "./uniqueId-321287e8.mjs";
import "./isClient-ec947a14.mjs";
import { c as k } from "./cloneSlots-333ddef1.mjs";
import { b as R, a as G } from "./useSlots-a1aa6a84.mjs";
import { u as H } from "./useQuantum-50e8fd44.mjs";
import { Badge as J } from "./badge.js";
import { C as z } from "./carousel-c5108cdc.mjs";
import "./helperText-d9646f54.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "react-dom";
import "./useMediaQuery-2533ee8a.mjs";
import "./buttonGroup.js";
import "./buttonV1.js";
import "./Aria-f5e019e2.mjs";
import "./combineRefs-90f27925.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
import "./closeButton.js";
import "./iconButton.js";
import "./button.js";
import "./index-2be68378.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./checkbox.js";
import "./label-33699561.mjs";
import "./popupTip.js";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
import "./menu.js";
import "./textInput.js";
import "./radio.js";
const I = K({
  size: "medium",
  borderBottom: !0
}), V = u.div`
  &.TabPanel {
    ${({
  theme: {
    components: { tabs: t }
  }
}) => T(t.TabPanel)};
  }
`, v = ({ children: t, className: s, index: i = 0, ...e }) => {
  const { activeTabIndex: a = 0, id: o } = C(I), l = E("tabpanel", {
    ariaLabelledBy: `tab-${o}-${i}`,
    tabIndex: 0
  });
  return a !== i ? null : /* @__PURE__ */ b(
    V,
    {
      id: `tabpanel-${o}-${i}`,
      ...l,
      ...e,
      className: d(["TabPanel", s]),
      children: t
    }
  );
}, Y = u.div`
  &.Tabs__tab-content-wrapper {
    ${({
  theme: {
    components: { tabs: t }
  }
}) => T(t.TabPanels)};
  }
`, F = ({ children: t, ...s }) => {
  const i = R(t, { panel: v }), e = k(i.panel, (a, o) => /* @__PURE__ */ A(
    v,
    {
      ...a,
      key: o,
      index: a.index ?? o,
      className: d(["TabPanels__Content", `TabPanels__Content-${a.index ?? o}`, a.className])
    }
  ));
  return /* @__PURE__ */ b(
    Y,
    {
      ...s,
      className: d(["TabPanels", s.className]),
      role: "tabpanel",
      children: e
    }
  );
};
F.Content = v;
const Z = u.button`
  &.Tab {
    ${({
  theme: {
    components: { tabs: t }
  }
}) => T(t.Tab)};
  }
`, tt = u.span`
  &.Tab__label {
    ${({
  theme: {
    components: { tabs: t }
  }
}) => T(t.Label)};
  }
`, x = ({ children: t, index: s = 0, className: i, isDisabled: e, badgeProp: a, ...o }) => {
  const { activeTabIndex: l = 0, setActiveTabIndex: m, size: p, badgeProp: f, id: y } = C(I), h = E("tab", {
    tabIndex: !e && l === s ? 0 : -1,
    ariaControls: `tabpanel-${y}-${s}`,
    ariaSelected: l === s
  }), _ = () => {
    e || m == null || m(s);
  }, $ = a || f;
  return /* @__PURE__ */ S(
    Z,
    {
      ...o,
      id: `tab-${y}-${s}`,
      onClick: _,
      disabled: e,
      ...h,
      className: d([
        "Tab",
        `Tab--${p}`,
        i,
        {
          "Tab--disabled": e,
          "Tab--active": l === s
        }
      ]),
      children: [
        /* @__PURE__ */ b(tt, { className: "Tab__label", children: t }),
        $ && /* @__PURE__ */ b(
          J,
          {
            ...$,
            className: d(["Tab__Badge", $.className]),
            size: p === "small" ? p : "medium"
          }
        )
      ]
    }
  );
}, et = u(z.Content)`
  &.TabList {
    ${({
  theme: {
    components: { tabs: t }
  }
}) => T(t.TabList)};
  }
`, st = u.div`
  &.TabList__indicator {
    ${({
  theme: {
    components: { tabs: t }
  }
}) => T(t.Indicator)};
  }
`, q = ({ children: t, ...s }) => {
  const i = B(null), { activeTabIndex: e = 0, setActiveTabIndex: a, size: o = "medium", borderBottom: l = !0, isBottomBorderFullWidth: m } = C(I), [p, f] = g(!1), y = G(i);
  M(() => {
    var N;
    const n = (N = i.current) == null ? void 0 : N.querySelectorAll(".TabsList__Item")[e];
    if (!n)
      return;
    const r = n.parentElement, { offsetWidth: L, offsetLeft: P } = n;
    n.classList.contains("Tab--disabled") ? (r.style.setProperty("--tabs-indicator-width", "0px"), r.style.setProperty("--tabs-indicator-position", `translateX(${P}px)`)) : (r.style.setProperty("--tabs-indicator-width", `${L + 1}px`), r.style.setProperty("--tabs-indicator-position", `translateX(${P}px)`));
  }, [e, y]);
  const h = (n) => {
    const r = D.Children.toArray(t), L = r.length, P = L - 1 === e, N = e === 0, W = () => {
      setTimeout(() => {
        const w = document.querySelector('[data-focus="true"] [aria-selected="true"]');
        w && w.focus();
      }, 0);
    }, X = () => {
      for (c = N ? L - 1 : e - 1; r[c].props.isDisabled; )
        c = c === 0 ? L - 1 : c - 1;
    }, j = () => {
      for (c = P ? 0 : e + 1; r[c].props.isDisabled; )
        c = c === L - 1 ? 0 : c + 1;
    };
    let c = e;
    n.key === "ArrowLeft" && X(), n.key === "ArrowRight" && j(), c !== e && (a == null || a(c)), n.key !== "Tab" && W();
  }, _ = R(t, { tab: x }), $ = k(_.tab, (n, r) => /* @__PURE__ */ A(
    x,
    {
      ...n,
      key: r,
      index: n.index ?? r,
      className: d(["TabsList__Item", `TabsList__Item-${n.index ?? r}`, n.className])
    }
  ));
  return /* @__PURE__ */ b(z, { hideControls: !0, children: /* @__PURE__ */ S(
    et,
    {
      ...s,
      ref: i,
      role: "tablist",
      onKeyDown: h,
      onFocus: () => f(!0),
      onBlur: () => f(!1),
      "data-focus": p,
      className: d([
        "TabList",
        `TabList--${o}`,
        s.className,
        {
          "TabList--borderBottom": l,
          "TabList--fullWidth": m
        }
      ]),
      children: [
        $,
        /* @__PURE__ */ b(st, { className: "TabList__indicator" })
      ]
    }
  ) });
};
q.Item = x;
const at = "Tabs", ot = u.div`
  &.Tabs {
    ${({
  theme: {
    components: { tabs: t }
  }
}) => T(t.Tabs)};
  }
`, O = ({
  children: t,
  size: s = "medium",
  borderBottom: i = !0,
  isBottomBorderFullWidth: e,
  badgeProp: a,
  activeTab: o = 0,
  setActiveTab: l,
  ...m
}) => {
  const p = H({ label: "Tabs" }), f = B(U(at)), [y, h] = g(o);
  Q(() => {
    h(o);
  }, [o]);
  const _ = {
    activeTabIndex: y,
    setActiveTabIndex: l || h,
    size: s,
    borderBottom: i,
    badgeProp: a,
    isBottomBorderFullWidth: e,
    id: f.current
  };
  return /* @__PURE__ */ b(I.Provider, { value: _, children: /* @__PURE__ */ b(
    ot,
    {
      ...m,
      ...p,
      className: d(["Tabs", m.className]),
      children: t
    }
  ) });
};
O.List = q;
O.Panel = F;
export {
  st as Indicator,
  x as Tab,
  q as TabList,
  v as TabPanel,
  F as TabPanels,
  O as Tabs
};
